export const API_SERVER = '';
export const XCSRF_TOKEN_HEADER = 'X-CSRF-Token';

export const TILE_SIZE_INIT_VALUE = 100;

export const PATH_SLASH = '/';

export const LOCAL_STORE_CONFIG_NAMES = {
   view: 'view',
   tileSize: 'tileSize',
   sortOption: 'sortOption',
   sortDirection: 'sortDirection',
};

export const versionNumber = '9.5.0.4589';
export const buildNumber = '20260505';

export const colors = {
   primaary: '#137eb0',
   secondary: '#9ccc51',
   lightGrey: '#f7f7f7',
} as const;

export const DELETE_FILE_MSG = 'Are you sure you want to permanently delete this file?';
export const DELETE_FOLDER_MSG = 'Are you sure you want to permanently delete this folder?';

export const NOTIFICATIONS_LENGTH = 198;

export const AUTH_DATA_STORE_KEY = 'auth';
